import css from 'styled-jsx/css';
import { zIndex, common } from '../../../theme/theme';

const style = css.global`
  .label {
    margin-bottom: 8px;
  }

  .create-user-contents {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .selector span {
    align-items: start;
  }
  .user-submit-button-container {
    margin-top: 8px;
  }

  .add-user-subtitle {
    font-size: 14px;
    font-weight: 600;
    font-family: Arial, Helvetica, sans-serif;
    color: black;
    padding-top: 15px;
    padding-bottom: 10px;
  }

  .user-submit-button-container :global(.submit-button) {
    ${common.button}
    ${common.submitButton}
  }

  .user-submit-button-container :global(.submit-button:hover) {
    ${common.button}
    ${common.submitButton}
  }
  .user-submit-button-container :global(.cancel-button) {
    ${common.button}
    ${common.cancelButton}
  }
  .user-submit-button-container :global(.cancel-button:hover) {
    ${common.button}
    ${common.cancelButton}
  }
`;

export default style;
